

































import Vue from "vue";
import { Book } from "../types/bibliocommons";

export default Vue.extend({
  props: {
    book: {
      type: Object as () => Book,
      required: true
    }
  }
});
